import { render, staticRenderFns } from "./treeSelect.vue?vue&type=template&id=a6fac586&scoped=true"
import script from "./treeSelect.vue?vue&type=script&lang=js"
export * from "./treeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fac586",
  null
  
)

export default component.exports